/**
 * kult-announcement.js — Versand-Ankündigung im Header mit Restbetrag.
 * Leer: Originaltext des Blocks. Mit Warenkorb: „Noch X € bis zum kostenlosen Versand“ (Grenze aus kult-versand-werte).
 * Die Grenze der Stufe gilt bei jeder Bestellung (Gold: tGold = 25 €, auch im Abo; 0 = immer versandfrei). Erreicht: Gratis-Hinweis.
 * Aktualisiert sich über kult:cart:add und kult:cart:updated (Detail: cart aus /cart.js).
 * Versand neu (cfg.v2, Schalter kult_versand_v2, 09.10.2026): Einzelkauf-Grenze nach Status (Neukunde tDefault 45 €,
 * Braun 35 €, Silber 29 €, Gold 25 €). Braun erst mit der ersten bezahlten Abo-Bestellung; Gast/Kunde ohne Kult-Abo = Neukunde.
 * Gold (Entscheidung Philip 09.10.2026): keine Gramm-Regel (aboFreiG = 0), die Euro-Grenze zählt auf den ganzen Warenkorb, auch mit Abo-Zeile.
 * Abo hat Vorrang (Entscheidung Philip 09.10.2026): Liegt eine Abo-Zeile im Warenkorb, gilt für den ganzen Warenkorb die
 * Abo-Regel nach Gramm (cfg.aboFreiG je Lieferung, kleinste Lieferung zählt), Texte cfg.restAbo / cfg.doneAbo.
 * Gemischter Warenkorb (Entscheidung Philip 11.10.2026, ersetzt D6, Plan §11.9): Abo-Zeile UND Einzelkauf = eine Sendung, einmal
 * Versand → versandfrei, wenn der ganze versandpflichtige Warenwert die Status-Grenze erreicht (Gast/Kunde mit Abo = Braun-Grenze
 * cfg.tClub) ODER alle Abo-Zeilen zusammen cfg.mixFreiG (auch Gold; Gold zeigt die Gold-Texte); sonst einmal cfg.aboVersand.
 * Dahinter die Folgelieferungen (cfg.mixFollow). Startwerte cfg.mix aus kult-cart-versand (gleiche Rechnung).
 */
(function () {
  'use strict';
  var cfgEl = document.querySelector('[data-kult-announce-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var targets = Array.prototype.slice.call(document.querySelectorAll('.announcement-bar__text')).filter(function (el) {
    return /versandkostenfrei/i.test(el.textContent);
  });
  if (!targets.length) return;
  targets.forEach(function (el) { el.setAttribute('data-kult-announce-original', el.innerHTML); });

  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  /* Grenze ohne Nachkommastellen, wenn ganzzahlig (45 €) */
  function moneyShort(cents) {
    return cents % 100 === 0 ? (cents / 100).toLocaleString('de-DE') + ' €' : money(cents);
  }
  function stufeName() { return cfg.state ? cfg.state.charAt(0).toUpperCase() + cfg.state.slice(1) : ''; }
  var aside = targets[0].closest('.announcement-bar');
  var bg = aside && aside.previousElementSibling && aside.previousElementSibling.classList.contains('section-background') ? aside.previousElementSibling : null;
  /* Mitglieder: Leiste dauerhaft in der Statusfarbe (26.09.2026) */
  if (cfg.member && cfg.stufe && aside) {
    aside.classList.add('kult-announce--stufe', 'kult-announce--stufe-' + cfg.stufe);
    if (bg) bg.classList.add('kult-announce--stufe', 'kult-announce--stufe-' + cfg.stufe);
  }
  /* „Kult Status Braun/Silber/Gold“ in der Metallfarbe hervorheben (Philip 16.10.2026) */
  function markiereStufen() {
    targets.forEach(function (el) {
      if (el.innerHTML.indexOf('Kult Status ') === -1 || el.innerHTML.indexOf('kult-announce__stufe') !== -1) return;
      el.innerHTML = el.innerHTML.replace(/Kult Status (Braun|Silber|Gold)/g, function (m, stufe) {
        return '<span class="kult-announce__stufe kult-announce__stufe--' + stufe.toLowerCase() + '">' + m + '</span>';
      });
    });
  }
  function setActive(on, done) {
    markiereStufen();
    if (!aside) return;
    aside.classList.toggle('kult-announce--active', on);
    aside.classList.toggle('kult-announce--done', on && done);
    if (bg) bg.classList.toggle('kult-announce--active', on);
  }
  function pill(pct) {
    return ' <span class="kult-announce__pill" aria-hidden="true"><span class="kult-announce__pill-fill" style="width:' + Math.max(0, Math.min(100, pct)) + '%"></span></span>';
  }
  /* Leerer Warenkorb: Mitglieder sehen den Status-Text (Section-Settings), alle anderen den Originaltext */
  function statusText(el) {
    var key = cfg.state === 'braun' ? 'textBraun' : cfg.state === 'silber' ? 'textSilber' : cfg.state === 'gold' ? 'textGold' : '';
    if (!key || !cfg[key]) return el.getAttribute('data-kult-announce-original');
    var html = '<strong>' + cfg[key] + '</strong>';
    if (cfg.state === 'braun' && cfg.linkLabel && cfg.linkUrl) {
      var a = document.createElement('a');
      a.href = cfg.linkUrl; a.textContent = cfg.linkLabel;
      html += ' · ' + a.outerHTML;
    }
    return html;
  }
  /* Gramm wie Calc.fmtGrams (assets/kult-abo-calc.js): „250 g“, volle Kilo als „1 kg“ */
  function fmtGrams(g) {
    return g > 0 && g % 1000 === 0 ? (g / 1000) + '\u00a0kg' : Math.round(g).toLocaleString('de-DE') + '\u00a0g';
  }
  /* Kleinste Abo-Lieferung in Gramm: Zeilen mit demselben Plan, Gramm aus der SKU KR-XXX-250|500|1000-YY; -1 = kein Abo */
  function aboMinGrams(items) {
    var plans = {};
    items.forEach(function (i) {
      var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
      if (!sp) return;
      var parts = String(i.sku || '').split('-');
      var g = parts.length === 4 && parts[0] === 'KR' ? (parseInt(parts[2], 10) || 0) * (i.quantity || 0) : 0;
      plans[sp.id] = (plans[sp.id] || 0) + g;
    });
    var ids = Object.keys(plans);
    return ids.length ? Math.min.apply(null, ids.map(function (k) { return plans[k]; })) : -1;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Einzelkauf-Grenze des Versand-Zustands (wie kult-versand-werte [8]) */
  function shipThreshold() {
    var s = cfg.shipState || cfg.state;
    if (s === 'gold') return typeof cfg.tGold === 'number' ? cfg.tGold : 0;
    if (s === 'silber') return cfg.tStatus;
    if (s === 'braun') return cfg.tClub;
    return cfg.tDefault;
  }
  /* Gemischter Warenkorb aus /cart.js (Rechnung wie snippets/kult-cart-versand.liquid [13]–[18]); null = nicht gemischt */
  function mixFromCart(items) {
    if (!cfg.v2) return null;
    var plans = {}, onetime = false, shipTotal = 0;
    items.forEach(function (i) {
      if (i.requires_shipping === false) return;
      shipTotal += i.final_line_price || 0;
      var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
      if (!sp) { onetime = true; return; }
      var p = plans[sp.id] || (plans[sp.id] = { g: 0, c: 0, name: sp.name || '', gift: true });
      // Geschenk-Abo (Prepaid, Property _kultgift_set): Versand aller Lieferungen bezahlt, keine Folgezeile (Later-Liste 22.10. Nr. 3)
      if (!(i.properties && i.properties._kultgift_set)) p.gift = false;
      var parts = String(i.sku || '').split('-');
      p.g += parts.length === 4 && parts[0] === 'KR' ? (parseInt(parts[2], 10) || 0) * (i.quantity || 0) : 0;
      p.c += i.final_line_price || 0;
    });
    var ids = Object.keys(plans);
    if (!ids.length || !onetime) return null;
    var t = cfg.member ? shipThreshold() : cfg.tClub, freiG = cfg.aboFreiG || 0, mixG = cfg.mixFreiG || freiG;
    var sumG = ids.reduce(function (s, k) { return s + plans[k].g; }, 0);
    var rest = t > 0 ? Math.max(0, t - shipTotal) : 0;
    var free = rest === 0 || (mixG > 0 && sumG >= mixG);
    if (free) rest = 0;
    var real = ids.filter(function (k) { return !plans[k].gift; });
    var under = real.some(function (k) { return freiG > 0 ? plans[k].g < freiG : (t > 0 && plans[k].c < t); });
    var rhythms = [];
    real.forEach(function (k) {
      var r = plans[k].name.replace(/Kult-Club|Kult-Abo/g, '').trim() || plans[k].name;
      r = r.replace(/Alle /g, 'alle ');
      if (rhythms.indexOf(r) < 0) rhythms.push(r);
    });
    var pct = free ? 100 : Math.max(t > 0 ? (shipTotal / t) * 100 : 0, freiG > 0 ? (sumG / freiG) * 100 : 0);
    return { free: free, rest: rest, restG: freiG > 0 && !free ? Math.max(0, freiG - sumG) : 0, follow: under ? (cfg.aboVersand || 0) : 0, rhythm: rhythms.join(' bzw. '), pct: pct, gold: freiG === 0, real: real.length > 0 };
  }
  /* Folgelieferungen des Kult-Abos (ab 600 px als eigene zweite Zeile, U14): „Dein Kult-Abo danach alle 4 Wochen: 2,90 € Versand (ab 1 kg je Lieferung kostenlos)“ */
  function followHtml(m) {
    if (!cfg.mixFollow || m.real === false) return '';
    var grenze = m.gold ? moneyShort(cfg.tGold || 0) : (cfg.aboFreiLabel || fmtGrams(cfg.aboFreiG));
    var txt = cfg.mixFollow.replace(/\{rhythmus\}/g, esc(m.rhythm || 'regelmäßig'))
      .replace(/\{versand\}/g, m.follow > 0 ? money(m.follow) + ' Versand' : 'versandkostenfrei')
      .replace(/\{grenze\}/g, grenze);
    return '<span class="kult-announce__follow">' + txt + '</span>';
  }
  function renderMix(m) {
    targets.forEach(function (el) {
      el.innerHTML = m.free
        ? '<strong>' + cfg.mixDone + '</strong>' + followHtml(m)
        : '<strong>' + cfg.mixRest.replace(/\{rest_g\}/g, fmtGrams(m.restG)).replace(/\{rest\}/g, money(m.rest)) + '</strong>' + pill(m.pct) + followHtml(m);
    });
    setActive(true, m.free);
  }
  function renderAbo(minG) {
    var rest = Math.max(0, cfg.aboFreiG - minG);
    var label = cfg.aboFreiLabel || fmtGrams(cfg.aboFreiG);
    targets.forEach(function (el) {
      el.innerHTML = rest > 0
        ? '<strong>' + cfg.restAbo.replace(/\{rest\}/g, fmtGrams(rest)).replace(/\{grenze\}/g, label) + '</strong>' + pill((minG / cfg.aboFreiG) * 100)
        : '<strong>' + cfg.doneAbo.replace(/\{grenze\}/g, label) + '</strong>';
    });
    setActive(true, rest === 0);
  }
  function render(total, hasClub, hasOnetime, aboMinG, mix, giftOnly) {
    /* Gemischt (10.10.2026): Gesamtwert oder Abo-Gramm entscheidet über diese Lieferung; Gold behält die Gold-Texte */
    if (mix && !mix.gold && cfg.mixDone && cfg.mixRest) { renderMix(mix); return; }
    /* Reines Kult-Abo (v2 mit Gramm-Grenze): nur die Abo-Regel */
    /* Nur Geschenk-Abos (Prepaid, Cowork 24.10.): Versand aller Lieferungen ist im Preis, kein „mit deinem Kult-Abo“ */
    if (giftOnly && hasClub && !hasOnetime && cfg.giftDone) { targets.forEach(function (el) { el.innerHTML = '<strong>' + cfg.giftDone + '</strong>'; }); setActive(true, true); return; }
    if (cfg.v2 && cfg.aboFreiG > 0 && hasClub && aboMinG >= 0 && cfg.restAbo) { renderAbo(aboMinG); return; }
    var status = cfg.state === 'silber' || cfg.state === 'gold';
    /* Grenze der Stufe bei jeder Bestellung (Gold 0 = immer); alte Werte: ohne Status die Abo-Grenze nur im reinen
       Abo-Warenkorb, sonst die Neukunden-Grenze. Der Club-Preis selbst gilt nur für Abo-Kaffee. */
    var aboOnly = hasClub && !hasOnetime && !cfg.v2;
    /* Grenze nach cfg.shipState (= state; Kunde ohne Kult-Abo = Neukunde, snippets/kult-versand-werte.liquid) */
    var shipState = cfg.shipState || cfg.state;
    var threshold;
    if (shipState === 'gold') threshold = typeof cfg.tGold === 'number' ? cfg.tGold : 0;
    else if (shipState === 'silber') threshold = cfg.tStatus;
    else if (shipState === 'braun') threshold = cfg.tClub;
    else threshold = aboOnly ? cfg.tClub : cfg.tDefault;
    var pct = threshold > 0 ? (total / threshold) * 100 : 100;
    /* Schwelle 0: direkt „Versandfrei“, auch bei leerem Warenkorb */
    if (threshold === 0) {
      targets.forEach(function (el) {
        if (!total || total <= 0) { el.innerHTML = statusText(el); return; }
        el.innerHTML = '<strong>' + (cfg.textGold || cfg.labelGold || cfg.labelDone) + '</strong>';
      });
      setActive(true, true);
      return;
    }
    targets.forEach(function (el) {
      if (!total || total <= 0) { el.innerHTML = statusText(el); return; }
      var rest = threshold - total;
      var tier = cfg.state === 'braun' || cfg.state === 'silber' || (cfg.v2 && cfg.state === 'gold');
      var gold = cfg.v2 && cfg.state === 'gold';
      if (rest <= 0) {
        if (gold && cfg.doneGold) { el.innerHTML = '<strong>' + cfg.doneGold + '</strong>'; return; }
        el.innerHTML = '<strong>' + (tier && cfg.doneStatus ? cfg.doneStatus.replace(/\{stufe\}/g, stufeName()) : cfg.labelDone) + '</strong>';
        return;
      }
      if (gold && cfg.restGold) {
        el.innerHTML = '<strong>' + cfg.restGold.replace(/\{rest\}/g, money(rest)).replace(/\{grenze\}/g, moneyShort(threshold)) + '</strong>' + pill(pct);
        return;
      }
      if (tier && cfg.restStatus) {
        el.innerHTML = '<strong>' + cfg.restStatus.replace(/\{rest\}/g, money(rest)).replace(/\{grenze\}/g, moneyShort(threshold)).replace(/\{stufe\}/g, stufeName()) + '</strong>' + pill(pct);
        return;
      }
      /* Gast/Kunde mit Abo-Zeile (alte Werte, Grenze = Abo-Grenze): Text aus den Section-Settings, ohne Status-Grenze (UX-Review N7) */
      if (!status && aboOnly && cfg.restClub) {
        el.innerHTML = '<strong>' + cfg.restClub.replace(/\{rest\}/g, money(rest)).replace(/\{grenze\}/g, moneyShort(threshold)) + '</strong>' + pill(pct);
        return;
      }
      var label = status && cfg.labelStatus ? cfg.labelStatus : ((cfg.member || aboOnly) ? cfg.labelClub : cfg.labelDefault);
      el.innerHTML = '<strong>Noch ' + money(rest) + '</strong> ' + label + ' (ab ' + moneyShort(threshold) + ')' + pill(pct);
    });
    /* Gold gemischt: Folgelieferungen des Kult-Abos hinter dem Gold-Text */
    if (mix && mix.gold && total > 0) targets.forEach(function (el) { el.insertAdjacentHTML('beforeend', followHtml(mix)); });
    setActive(total > 0, total >= threshold);
  }
  function fromCart(cart) {
    if (!cart) return;
    var items = cart.items || [];
    var hasClub = items.some(function (i) { return !!i.selling_plan_allocation; });
    var hasOnetime = items.some(function (i) { return !i.selling_plan_allocation && i.requires_shipping !== false; });
    /* v2: nur Einzelkauf-Zeilen zählen für die Einzelkauf-Grenze */
    var total = cfg.v2 && cfg.shipState !== 'gold'
      ? items.reduce(function (sum, i) { return i.selling_plan_allocation ? sum : sum + (i.final_line_price || 0); }, 0)
      : (cart.total_price || 0);
    var plansOnly = items.filter(function (i) { return !!i.selling_plan_allocation; });
    var giftOnly = plansOnly.length > 0 && plansOnly.every(function (i) { return i.properties && i.properties._kultgift_set; });
    render(total, hasClub, hasOnetime, aboMinGrams(items), mixFromCart(items), giftOnly);
  }
  render(cfg.cartTotal, cfg.hasClub, cfg.hasOnetime, typeof cfg.aboMinG === 'number' ? cfg.aboMinG : -1, cfg.mix || null, cfg.giftOnly === true);
  document.addEventListener('kult:cart:add', function (e) { fromCart(e.detail && e.detail.cart); });
  document.addEventListener('kult:cart:updated', function (e) { fromCart(e.detail && e.detail.cart); });
})();
